import {
  UPDATE_BACKGROUND_COLOR,
  UPDATE_SPIN_BEHAVIOR,
  UPDATE_WHEEL_COLORS,
  UPDATE_MUSIC,
  UPDATE_CONFETTI,
  UPDATE_ALL_SETTINGS,
  UPDATE_MUSIC_VOLUME,
  UPDATE_SPIN_BUTTON,
  UPDATE_BACKGROUND_IMAGE,
  UPDATE_BANNERS,
  RESET_INITIAL_SETTINGS,
  TURN_OFF_PREMIUM_SETTINGS,
  INSTANT_INIT_SETTINGS,
  UPDATE_RTG_SPIN_BEHAVIOR,
  SET_IMAGE_DISPLAY_SIZE,
  // UPDATE_TOOL_BACKGROUND_COLOR,
  SET_TOOL_BACKGROUND_TRANSPARENCY,
} from './constants'
import { setDataStatus } from '../common/actions'
import { refreshTurntable } from '../turntable/actions'

export const updateBgColor = (color, theme) => dispatch => {
  dispatch({
    type: UPDATE_BACKGROUND_COLOR,
    payload: {
      color,
      theme,
    },
  })
  dispatch(setDataStatus('Modified', 'Tool Settings'))
}

export const updateWheelColors =
  (colors, index, arrayKey, page = '') =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: UPDATE_WHEEL_COLORS,
        payload: {
          colors,
          index,
          arrayKey,
        },
      })
      // this is to redraw all the wheels with new colors, rmb to add new wheel here
      dispatch(refreshTurntable(page))
      dispatch(setDataStatus('Modified', 'Tool Settings'))
    } catch (error) {
      console.log(error)
    }
  }

// const updateWheelColorsAction = (colors, index, arrayKey) => ({
//   type: UPDATE_WHEEL_COLORS,
//   payload: {
//     colors,
//     index,
//     arrayKey,
//   },
// })

export const updateSpinBehavior =
  (
    speed,
    duration,
    manualStop,
    randomStart,
    // mysterySpin,
    spinQuantity,
    initialSpinning,
    buttonAnimation,
    page = '',
  ) =>
  async (dispatch, getState) => {
    try {
      const state = getState()
      // const pastMysterySpin = state.settings.spinBehavior.mysterySpin
      const pastInitialSpinning = state.settings.spinBehavior.initialSpinning
      dispatch({
        type: UPDATE_SPIN_BEHAVIOR,
        payload: {
          speed,
          duration,
          manualStop,
          randomStart,
          // mysterySpin,
          spinQuantity,
          initialSpinning,
          buttonAnimation,
        },
      })
      // this is to redraw all the wheels with new colors, rmb to add new wheel here
      if (
        // pastMysterySpin !== mysterySpin ||
        pastInitialSpinning !== initialSpinning
      ) {
        dispatch(refreshTurntable(page))
      }
      dispatch(setDataStatus('Modified', 'Tool Settings'))
    } catch (error) {
      console.log(error)
    }
  }

// export const updateSpinBehaviorAction = (
//   speed,
//   duration,
//   manualStop,
//   randomStart,
//   mysterySpin,
// ) => ({
//   type: UPDATE_SPIN_BEHAVIOR,
//   payload: {
//     speed,
//     duration,
//     manualStop,
//     randomStart,
//     mysterySpin,
//   },
// })

export const updateMusic =
  (soundOn, starting, spinning, celebrating, customOn) => dispatch => {
    dispatch({
      type: UPDATE_MUSIC,
      payload: {
        soundOn,
        starting,
        spinning,
        celebrating,
        customOn,
      },
    })
    dispatch(setDataStatus('Modified', 'Tool Settings'))
  }

export const updateConfetti = confettiOn => dispatch => {
  dispatch({
    type: UPDATE_CONFETTI,
    payload: {
      confettiOn,
    },
  })
  dispatch(setDataStatus('Modified', 'Tool Settings'))
}

export const updateAllSettings =
  (settings, page = '') =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: UPDATE_ALL_SETTINGS,
        payload: {
          settings,
        },
      })
      // this is to redraw all the wheels with new colors, rmb to add new wheel here
      dispatch(refreshTurntable(page))
      dispatch(setDataStatus('Unchanged')) //load from sharewheel and load list
    } catch (error) {
      console.log(error)
    }
  }

// const updateAllSettingsAction = settings => ({
//   type: UPDATE_ALL_SETTINGS,
//   payload: {
//     settings,
//   },
// })

export const updateMusicVolume = (volume, soundOn) => dispatch => {
  dispatch({
    type: UPDATE_MUSIC_VOLUME,
    payload: {
      volume,
      soundOn,
    },
  })
  dispatch(setDataStatus('Modified', 'Tool Settings'))
}

export const updateSpinButton =
  (colorOn, color, imageOn, image) => dispatch => {
    dispatch({
      type: UPDATE_SPIN_BUTTON,
      payload: {
        colorOn,
        color,
        imageOn,
        image,
      },
    })
    dispatch(setDataStatus('Modified', 'Tool Settings'))
  }

export const updateBackgroundImage = (on, src) => dispatch => {
  dispatch({
    type: UPDATE_BACKGROUND_IMAGE,
    payload: { on, src },
  })
  dispatch(setDataStatus('Modified', 'Tool Settings'))
}

export const updateBanners = (on, srcObj) => dispatch => {
  dispatch({
    type: UPDATE_BANNERS,
    payload: { on, srcObj },
  })
  dispatch(setDataStatus('Modified', 'Tool Settings'))
}

export const resetInitialSettings = () => {
  return {
    type: RESET_INITIAL_SETTINGS,
  }
}

export const instantInitSettings = previousState => {
  return {
    type: INSTANT_INIT_SETTINGS,
    payload: {
      previousState,
    },
  }
}

export const turnOffPremiumSettings = () => {
  return {
    type: TURN_OFF_PREMIUM_SETTINGS,
  }
}

export const updateRTGSpinBehavior =
  (grouping, representative, wheel) => dispatch => {
    dispatch({
      type: UPDATE_RTG_SPIN_BEHAVIOR,
      payload: {
        grouping,
        representative,
        wheel,
      },
    })
    dispatch(setDataStatus('Modified', 'Tool Settings'))
  }

export const setImageDisplaySize = imageDisplaySize => dispatch => {
  dispatch({
    type: SET_IMAGE_DISPLAY_SIZE,
    payload: {
      imageDisplaySize,
    },
  })
  dispatch(setDataStatus('Modified', 'Tool Settings'))
}

export const setToolBgTransparency = transparency => dispatch => {
  dispatch({
    type: SET_TOOL_BACKGROUND_TRANSPARENCY,
    payload: {
      transparency,
    },
  })
  dispatch(setDataStatus('Modified', 'Tool Settings'))
}
